import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
	const [isLoggedIn, setIsLoggedIn] = useState(false);
	const [user, setUser] = useState(null);

	const fetchUserFromServer = async (token) => {
		try {
			const response = await axios.get(
				`${process.env.REACT_APP_API_URL}/api/users/user`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			);

			setUser(response.data);
			setIsLoggedIn(true);
		} catch (error) {
			console.error("Błąd podczas pobierania użytkownika", error);

			// ⭐ Jeśli token nieważny → usuń go i wyloguj
			localStorage.removeItem("authToken");
			setUser(null);
			setIsLoggedIn(false);
		}
	};

	useEffect(() => {
		const token = localStorage.getItem("authToken");

		if (token) {
			fetchUserFromServer(token);
		}
	}, []);

	const login = async (token) => {
		localStorage.setItem("authToken", token);
		await fetchUserFromServer(token);
	};

	const logout = () => {
		localStorage.removeItem("authToken");
		setIsLoggedIn(false);
		setUser(null);
	};

	return (
		<AuthContext.Provider value={{ isLoggedIn, user, login, logout }}>
			{children}
		</AuthContext.Provider>
	);
};
